<div class="flex" [class.error]="error" #input>
  <ng-content select="[custom-input]"></ng-content>
  <ng-content select="[custom-label]"></ng-content>
  <ng-content select="[error-icon]"></ng-content>
  <ng-content select="[custom-suffix]"></ng-content>
  <ng-content select="[custom-prefix]"></ng-content>
</div>
<div class="errors-box" [class.error]="error" #errorsBox>
  <ng-content select="[custom-error]"></ng-content>
</div>